/**
 * @description to adapt redirection link to back-office Climate for each env
 */
const climateEnvLink = () => {
    const env = process.env.REACT_APP_ACTIVE_MODE;

    switch (true) {
        case env === 'RECETTE':
            return 'https://rc-climatekit.paygreen.fr';
        case env === 'SANDBOX':
            return 'https://sb-climatekit.paygreen.fr';
        case env === 'PRODUCTION':
            return 'https://climatekit.paygreen.fr';
        default:
            return 'https://rc-climatekit.paygreen.fr'; // default is for local tests
    }
};

export { climateEnvLink };
